module.exports = __webpack_public_path__ + "d39fd25b7e3708f60b856a38cdc87b5b.png";